export class ComputeVcdConstants {
    public static  ALLOC_MODEL = {
        PAYGO : 'RESERVATIONPOOL',
        ALLOCPOOL : 'ALLOCATIONPOOL'
    };
}



// WEBPACK FOOTER //
// ./src/app/components/compute/compute-vcd/compute-vcd-constants.ts